// extracted by mini-css-extract-plugin
export default {"container":"Main_container__4+82d","mainContent":"Main_mainContent__cZUv5","sideBarMenu":"Main_sideBarMenu__QGFuZ"};